import { Scope } from '../shared';

export const mandateAgreementRequired = {
  id: 'mandateAgreementRequired',
  name: _TL_('Mandate Agreement Required'),
  route: 'MandateAgreementRequired',
  checkPermission: permissions => permissions.dynamic.MandateAgreementRequired,
  scope: [Scope.Customer],
};
